<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        color="error"
        class="mr-3"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>Confirma que deseja deletar o grupo de solução?</h2>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="beforeDelete">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityGroupSolutionAPI } from '@/modules/city/API/CityGroupSolutionAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppModalDeleteAxis',
  props: {
    payload: { type: Object, required: true }
  },
  data () {
    return {
      dialog: false
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    onConfirm () {
      cityGroupSolutionAPI.delete(this.payload.municipioGrupoSolucaoId)
        .then(resp => {
          this.setLoading(false)
          this.dialog = false
          this.$emit('onDelete')
        })
        .catch(resp => {
          this.$notification.error('Erro ao deletar grupo de solução')
          this.setLoading(false)
        })
    },
    beforeDelete () {
      this.setLoading(true)
      cityGroupSolutionAPI.groupSolutionStarted(this.payload)
        .then(resp => {
          if (resp.data === false) {
            this.onConfirm()
          } else {
            this.setLoading(false)
            this.$notification.error('Grupo de solução já iniciado')
          }
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao deletar grupo de solução')
        })
    }
  }
}
</script>
